import HomeworkChunk from './HomeworkChunk';

export default HomeworkChunk;
